var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"controller"},[_c('Controller',{on:{"direction":function($event){return _vm.keyDownHandler($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }